import { Route, Routes } from "react-router-dom";
import "./App.css";
import CartPage from "./components/weddigservice/CartPage";
import AllServicesPage from "./components/weddigservice/allservice";
import PrivacyPolicy from "./components/weddigservice/Privacypage";
import Allshoppage from "./components/weddigservice/Shop";
import ServicePage from "./components/weddigservice/ServicePage";
import OTPSender from "./components/Auth/mobileotp";
import Subcategorypage from "./components/weddigservice/subservice";
import { useEffect } from "react";
import CategoryProductListPage from "./pages/CategoryProductListPage";
import MerchantProductListPage from "./pages/MerchantProductListPage";
import { DISPLAY_CATEGORY_TYPE } from "utils/constants";
import AnalyticsService from "./services/analytics.service";
import Selectcity from "components/popup/selectAreaPopup";
import SelectAreaPopup from "components/popup/selectAreaPopup";
import { LocalStorageUtils } from "utils/localstorage.utils";
import CustomerProductListPage from "pages/CustomerProductListPage";
import CustomerProductItemPage from "pages/CustomerProductItemPage";
import AddCustomerProductItemPage from "pages/AddCustomerProductPage";
import { AreaApi } from "api/area.api";
import TermsAndConditions from "components/termandcondition/terms";
import AllOrders from "components/weddigservice/order/orderlist";
import ThankYouOrderPopup from "components/test";
import OrderDetailsPage from "pages/OrderDetailsPage";
import DeepLinkRedirect from "pages/DeeplinkPage";

function App() {
  const areaId = LocalStorageUtils.getAreaId();
  const pathname = window.location.pathname;

  useEffect(() => {
    AnalyticsService.identifyUser();
    AreaApi.refreshAreaCache();
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <AllServicesPage displayCategoryType={DISPLAY_CATEGORY_TYPE.Food} />
          }
        />
        <Route
          path="/products"
          element={
            <AllServicesPage
              displayCategoryType={DISPLAY_CATEGORY_TYPE.GroceryProduct}
            />
          }
        />
        <Route path="/shops" element={<Allshoppage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="/customer-products/:postType" element={<CustomerProductListPage />} />
        <Route path="/customer-products/:postType/add" element={<AddCustomerProductItemPage />} />
        <Route path="/customer-products/:postType/:customerProductId" element={<CustomerProductItemPage />} />
        <Route
          path="/category-products/:displayCategoryId"
          element={<CategoryProductListPage />}
        />
        <Route
          path="/merchant-products/:merchantId"
          element={<MerchantProductListPage />}
        />
        <Route path="/sub/category/:category" element={<Subcategorypage />} />

        <Route path="/cart" element={<CartPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/select-city" element={<Selectcity />} />
        <Route path="/test" element={<ThankYouOrderPopup />} />
        <Route path="/menu" element={<AllOrders />} />
        <Route path="/order/:orderId" element={<OrderDetailsPage />} />
        <Route path="/app/*" element={<DeepLinkRedirect />} />
      </Routes>
      {!areaId && pathname !== "/app" && <SelectAreaPopup hideCloseButton={true} />}
    </div>
  );
}

export default App;
